import { PipeTransform, Pipe } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({ name: 'translateSlice' })
export class TranslateSlice implements PipeTransform {

  constructor(private translateService: TranslateService) { }
  transform(value: string): string {
    const words = value.split(" ");
    const total = words.length;
    let retour = '';
    for (let i = 0; i < total; i++) {
      let translated = '';
      try {
        if (words[i] !== "") {
          translated = this.translateService.instant(words[i]);
        }
        else {
          translated = words[i];
        }
      }
      catch (ex) {
        var a = ex;
      }
      retour += translated;
      if (i < total - 1)
        retour += " ";
    }
    return retour;
    }
}
